import { useTranslation } from "react-i18next";
import React from "react";
import { NavLink } from "react-router-dom";

const RightSidebar = () => {
  const { t } = useTranslation();
  const headerLinksAarray = [
    {
      className: "link",
      to: "/reports/inprogress",
      text: t("pendingReports"),
    },
    {
      className: "link",
      to: "/reports/followup",
      text: t("allReports"),
    },
    {
      className: "link",
      to: "/reports/followup-messages",
      text: t("messages"),
    },
    {
      className: "link",
      to: "/control-center/manage-content",
      text: t("contentManagement"),
    },
    {
      className: "link",
      to: "/control-center/manage-parameters/",
      text: t("parametersManagement"),
    },
    {
      className: "link",
      to: "/control-center/users-permissions",
      text: t("usersPermissionsManagement"),
    },
    {
      className: "link",
      to: "/control-center/reports/",
      text: t("reportsTab"),
    },
    {
      className: "link",
      to: "/control-center/online-dashboard",
      text: t("onlineDashboard"),
    },
    {
      className: "link",
      to: "/control-center/administrative-dashboard",
      text: t("administrativeDashboard"),
    },
  ];

  const linksJsx = headerLinksAarray.map((route) => (
    <NavLink {...route} key={route.to}>
      {route.text}
    </NavLink>
  ));

  return <nav className="right-sidebar">{linksJsx}</nav>;
};

export default RightSidebar;
